import { LinesModel } from '@shared/models/lines.model';

export interface SoundStyle {
  name: LinesModel;
  value: string;
  src: string | null;
}

export const SOUND_STYLES: SoundStyle[] = [
  {
    name: { ru: 'Нет', en: 'Off' },
    value: 'off',
    src: null,
  },
  {
    name: { ru: 'Капля воды', en: 'Water Drop' },
    value: 'waterDrop',
    src: 'assets/sounds/water-drop.mp3',
  },
  {
    name: { ru: 'Монета', en: 'Coin Drop' },
    value: 'coinDrop',
    src: 'assets/sounds/coin-drop.mp3',
  },
];
